//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 地図/径間ポップアップ
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import '@esri/calcite-components/dist/components/calcite-tab';
import '@esri/calcite-components/dist/components/calcite-tabs';
import '@esri/calcite-components/dist/components/calcite-tab-nav';
import '@esri/calcite-components/dist/components/calcite-tab-title';
import '@esri/calcite-components/dist/components/calcite-button';
import {
  CalciteTab,
  CalciteTabs,
  CalciteTabNav,
  CalciteTabTitle,
  CalciteButton,
} from '@esri/calcite-components-react'
import { PoleAttribute, PoleAttributes } from '@/components/map-pole-attr';
import PoleItem from '@/utils/pole-item';
import PoleLink from '@/utils/pole-link';
import PopupKeikanList from './link-keikan';

// 定数
const LOGH = 'BFA10104G link popup:';

/**
 * 径間ポップアップタイトル
 */
export const linkPopupTitle = (attr) => [
  PoleItem.longText(attr.link?.pole1st),
  PoleItem.longText(attr.link?.pole2nd),
];

/**
 * 径間ポップアップ内容
 */
export function LinkPopupContent({
  link,
  setubiMap,
  keikanList,
  onKeikanAdd,
  onKeikanEdit,
  onKeikanDelete,
}) {

  // 設備一覧絞り込み
  const selfList = keikanList.filter((kkn) => {
    const pole1 = new PoleItem({
      areaCode: kkn.k1areaCode,
      lineCode: kkn.k1lineCode,
      poleNo:   kkn.k1poleNo,
    });
    const pole2 = new PoleItem({
      areaCode: kkn.k2areaCode,
      lineCode: kkn.k2lineCode,
      poleNo:   kkn.k2poleNo,
    });
    const kknLink = new PoleLink(pole1, pole2);
    return kknLink.same(link);
  });

  // 選択したタブ
  const [ tabSelected, setTabSelected ] = React.useState(null);
  const tab = tabSelected || 'keikan';

  // 径間追加ボタン処理
  const handleKeikanAdd = React.useCallback(() => {
    console.info(LOGH, '径間追加', link?.toString());
    onKeikanAdd(link);
  }, [link, onKeikanAdd]);

  // 描画
  const pole1 = link?.pole1st;
  const pole2 = link?.pole2nd;
  return (
    <>
      {/* タブ [電柱1][電柱2][径間] */}
      <CalciteTabs scale="s">
        <CalciteTabNav slot="title-group">

          {/* 電柱(1) */}
          <CalciteTabTitle
            selected={tab === 'pole1'}
            onCalciteTabsActivate={() => setTabSelected('pole1')}
          >
            電柱(1)
          </CalciteTabTitle>

          {/* 電柱(2) */}
          <CalciteTabTitle
            selected={tab === 'pole2'}
            onCalciteTabsActivate={() => setTabSelected('pole2')}
          >
            電柱(2)
          </CalciteTabTitle>

          {/* 径間 */}
          <CalciteTabTitle
            selected={tab === 'keikan'}
            onCalciteTabsActivate={() => setTabSelected('keikan')}
          >
            径間
          </CalciteTabTitle>
        </CalciteTabNav>

        {/* [タブ] 電柱属性(1) */}
        <CalciteTab style={{ height: '7.5rem' }}>
          <PoleAttributes cssStyle={{ marginTop: '8px' }}>
            <PoleAttribute label="地区"     value={pole1.areaName} />
            <PoleAttribute label="冠称"     value={pole1.lineName} />
            <PoleAttribute label="電柱番号" value={pole1.text()} />
            <PoleAttribute label="施設名"   value={pole1.poleKind} />
          </PoleAttributes>
        </CalciteTab>

        {/* [タブ] 電柱属性(2) */}
        <CalciteTab style={{ height: '7.5rem' }}>
          <PoleAttributes cssStyle={{ marginTop: '8px' }}>
            <PoleAttribute label="地区"     value={pole2.areaName} />
            <PoleAttribute label="冠称"     value={pole2.lineName} />
            <PoleAttribute label="電柱番号" value={pole2.text()} />
            <PoleAttribute label="施設名"   value={pole2.poleKind} />
          </PoleAttributes>
        </CalciteTab>

        {/* [タブ] 径間一覧 */}
        <CalciteTab style={{ height: '7.5rem' }}>
          <PopupKeikanList
            keikanList={selfList}
            setubiMap={setubiMap}
            onKeikanEdit={onKeikanEdit}
            onKeikanDelete={onKeikanDelete}
          />
        </CalciteTab>
      </CalciteTabs>

      {/* フッター (右揃え) */}
      <div style={{
        display: 'flex',
        marginTop: '12px',
        flexDirection: 'row',
        justifyContent: 'flex-end',
      }}>
        {/* 径間追加ボタン */}
        <CalciteButton onClick={handleKeikanAdd}>
          径間追加
        </CalciteButton>
      </div>
   </>
  );
}

// プロパティ
LinkPopupContent.propTypes = {
  link:       PropTypes.object,             // 径間情報
  keikanList: PropTypes.array,              // 径間一覧
  setubiMap:  PropTypes.instanceOf(Map),    // 架設設備マップ

  // イベントハンドラー
  onKeikanAdd:    PropTypes.func.isRequired,     // 径間追加
  onKeikanEdit:   PropTypes.func.isRequired,     // 径間編集
  onKeikanDelete: PropTypes.func.isRequired,     // 径間削除
};

// デフォルトエクスポート
export default LinkPopupContent;
